/**
 * QA Perspective Label
 *
 * NOTE: This component is now deprecated and returns null.
 * Perspective indicator has been moved into the QA toolbar.
 */

export const QAPerspectiveLabel = () => {
  // Perspective indicator is now part of QA toolbar
  return null
}
